import Text from 'components/Text'
import React from 'react'

export default function TextBodySmallest (props) {
  return (
    <Text
      fs='smallest'
      {...props}
    />
  )
}
